import React, { memo } from "react";
import "./footer.css";
import logo from "./assets/logo.png"; // Adjust the path as needed
import instagram from "./assets/instagram.png"; // Adjust the path as needed
import facebook from "./assets/facebook.png"; // Adjust the path as needed
import linkedin from "./assets/linkedin.png"; // Adjust the path as needed

const socialLinks = [
  {
    href: "https://www.instagram.com/rho1914",
    img: instagram,
    alt: "Instagram",
  },
  { href: "https://www.facebook.com/rho1914", img: facebook, alt: "Facebook" },
  {
    href: "https://www.linkedin.com/company/rho1914",
    img: linkedin,
    alt: "LinkedIn",
  },
];

const Footer = memo(() => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-left">
          <img src={logo} alt="Logo" className="logo-img" />
          <p>The Only Single-Letter Alumni Chapter</p>
        </div>
        <div className="footer-middle">
          <h1>
            <span className="rho-text">RHO </span> CHAPTER
          </h1>
          <h5>MANLY DEEDS, SCHOLARSHIP, AND LOVE FOR ALL MANKIND! </h5>
          <p>©{currentYear} Alpha Phi Alpha Fraternity, Inc. | Rho Chapter</p>
          <p>All Rights Reserved</p>
        </div>
        <div className="footer-right">
          <div className="learn-more">
            <h2>Learn More</h2>
            <a
              href="https://www.rho1914.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <p>rho1914.com</p>
            </a>
          </div>
          <div className="social-media">
            <h2>Stay Connected</h2>
            {socialLinks.map(({ href, img, alt }) => (
              <a
                key={alt}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={img} alt={alt} className="social-icon" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
});

export default Footer;
